/**
 * backlogModalMutex
 * -----------------
 * Two providers can surface a backlog-fee dialog:
 *   • GlobalBacklogModalProvider  → Open-Banking (Mono/Plaid) backlog
 *   • GlobalUploadBacklogModalProvider → Manual PDF/statement upload backlog
 *
 * Historically both could open at the SAME time (same user has a stale
 * Mono backlog AND just uploaded a PDF) producing two visually similar
 * dialogs stacked on top of each other — the "duplicated modal" bug
 * reported repeatedly.
 *
 * This mutex exposes a shared claim so at most one dialog is visible.
 * The other provider hides its dialog and re-fires as soon as the
 * primary one releases the lock (Confirm / Decline / Cancel).
 */

const LISTENERS = new Set();
let holder = null; // 'openbanking' | 'upload' | null

export const claimBacklogModal = (owner) => {
  if (holder && holder !== owner) return false;
  if (holder === owner) return true;
  holder = owner;
  for (const cb of LISTENERS) { try { cb(holder); } catch (_) { /* noop */ } }
  return true;
};

export const releaseBacklogModal = (owner) => {
  if (holder !== owner) return;
  holder = null;
  for (const cb of LISTENERS) { try { cb(holder); } catch (_) { /* noop */ } }
};

export const getBacklogModalHolder = () => holder;

// Subscribe to holder changes. Returns unsubscribe.
export const subscribeBacklogModal = (cb) => {
  LISTENERS.add(cb);
  return () => { LISTENERS.delete(cb); };
};
